<template>
  <div class="heightSet">
    <div style="display: flex;justify-content: flex-end;padding: 15px;height:64px;">
      <div style="display:flex;width: 100%;justify-content: space-between;">
        <div class="search-bar-comm-style">
          <input type="text" v-model="searchedKey" class="rounded text-light search-bar"
            :placeholder="$t('Search privilege')" />
          <div class="dropdown privilege-options-dropdown" v-click-outside-privilege-menu>
            <button type="button" class="three-dot-btn" @click="dropdownOpen = !dropdownOpen"
              :aria-expanded="dropdownOpen" aria-haspopup="true">
              <span class="three-dot-icon">&#8942;</span>
            </button>
            <div class="dropdown-menu privilege-dropdown-menu" :class="{ show: dropdownOpen }">
              <a class="dropdown-item" href="javascript:void(0)" @click="togglePrivilegeIdVisibility">
                {{ showPrivilegeIds ? $t('Hide privilege id') : $t('Show privilege id') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="privileges-ul">
      <div class="pb-2 m-4 d-flex" v-if="userAllPrivileges.Basic && userAllPrivileges.Basic.length"
        style="border-bottom: 1px solid #242424;position:relative">
        <h6 class="m-0 text-left pl-4">{{ $t('Basic Privileges') }}</h6>
      </div>
      <template v-if="userAllPrivileges.Basic">
        <li v-for="key in userAllPrivileges.Basic" :key="key._id">
          <template
            v-if="!searchedKey || (searchedKey && key.name.toLowerCase().includes(searchedKey.trim().toLowerCase()))">
            <div class="custom-control custom-switch category-div">
              <input v-on:click="updatePrivileges(key, $event.target.checked, 'Basic')" :id="key._id" type="checkbox"
                class="custom-control-input"
                :checked="listOfPrivileges.includes(key._id) || selectPrivilgeSections.Basic == true" />
              <label class="custom-control-label category-label" for="customSwitch1">
                <div class="category-head">{{ $t(key.name) }}</div>
                <div v-if="Object.keys(key).includes('about')" class="config-label category-desc">
                  {{ $t(key.about) }}
                </div>
                <!-- <div v-else class="config-label category-desc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </div> -->
                <div v-if="showPrivilegeIds" class="category-privilege-id">
                  <span class="privilege-id-text">{{ key._id }}</span>
                  <span class="privilege-id-copy-icon" :title="$t('Click to copy')"
                    @click.prevent.stop="copyPrivilegeId(key._id)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6" />
                      <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6" />
                    </svg>
                  </span>
                </div>
              </label>
            </div>
          </template>
        </li>
      </template>
      <div class="pb-2 m-4 d-flex" v-if="userAllPrivileges.DAM && userAllPrivileges.DAM.length"
        style="border-bottom: 1px solid #242424;position:relative">
        <h6 class="m-0 text-left pl-4">{{ $t('FUSION Privileges') }}</h6>
      </div>
      <template v-if="userAllPrivileges.DAM">
        <li v-for="key in userAllPrivileges.DAM" :key="key._id">
          <template
            v-if="!searchedKey || (searchedKey && key.name.toLowerCase().includes(searchedKey.trim().toLowerCase()))">
            <div class="custom-control custom-switch category-div">
              <input v-on:click="updatePrivileges(key, $event.target.checked, 'DAM')" :id="key._id" type="checkbox"
                class="custom-control-input"
                :checked="listOfPrivileges.includes(key._id) || selectPrivilgeSections.DAM == true" />
              <label class="custom-control-label category-label">
                <div class="category-head">{{ $t(key.name) }}</div>
                <div v-if="Object.keys(key).includes('about')" class="config-label category-desc">
                  {{ $t(key.about) }}
                </div>
                <!-- <div v-else class="config-label category-desc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </div> -->
                <div v-if="showPrivilegeIds" class="category-privilege-id">
                  <span class="privilege-id-text">{{ key._id }}</span>
                  <span class="privilege-id-copy-icon" :title="$t('Click to copy')"
                    @click.prevent.stop="copyPrivilegeId(key._id)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6" />
                      <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6" />
                    </svg>
                  </span>
                </div>
              </label>
            </div>
          </template>
        </li>
      </template>
      <div class="pb-2 m-4 d-flex" v-if="userAllPrivileges.Archive && userAllPrivileges.Archive.length"
        style="border-bottom: 1px solid #242424;position:relative">
        <h6 class="m-0 text-left pl-4">{{ $t('Archive Privileges') }}</h6>
      </div>
      <template v-if="userAllPrivileges.Archive">
        <li v-for="key in userAllPrivileges.Archive" :key="key._id">
          <template
            v-if="!searchedKey || (searchedKey && key.name.toLowerCase().includes(searchedKey.trim().toLowerCase()))">
            <div class="custom-control custom-switch category-div">
              <input v-on:click="updatePrivileges(key, $event.target.checked, 'Archive')" type="checkbox" :id="key._id"
                class="custom-control-input"
                :checked="listOfPrivileges.includes(key._id) || selectPrivilgeSections['Archive']" />
              <label class="custom-control-label category-label" for="customSwitch3">
                <div class="category-head">{{ $t(key.name) }}</div>
                <div v-if="Object.keys(key).includes('about')" class="config-label category-desc">
                  {{ $t(key.about) }}
                </div>
                <!-- <div v-else class="config-label category-desc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </div> -->
                <div v-if="showPrivilegeIds" class="category-privilege-id">
                  <span class="privilege-id-text">{{ key._id }}</span>
                  <span class="privilege-id-copy-icon" :title="$t('Click to copy')"
                    @click.prevent.stop="copyPrivilegeId(key._id)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6" />
                      <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6" />
                    </svg>
                  </span>
                </div>
              </label>
            </div>
          </template>
        </li>
      </template>
      <template v-if="userAllPrivileges['AI Tools']">
        <div class="pb-2 m-4 d-flex" v-if="userAllPrivileges['AI Tools'].length"
          style="border-bottom: 1px solid #242424;position:relative">
          <h6 class="m-0 text-left pl-4">{{ $t('AI Tools') }}</h6>
        </div>
        <li v-for="key in userAllPrivileges['AI Tools']" :key="key._id">
          <template
            v-if="!searchedKey || (searchedKey && key.name.toLowerCase().includes(searchedKey.trim().toLowerCase()))">
            <div class="custom-control custom-switch category-div">
              <input v-on:click="updatePrivileges(key, $event.target.checked, 'AI Tools')" type="checkbox" :id="key._id"
                class="custom-control-input"
                :checked="listOfPrivileges.includes(key._id) || selectPrivilgeSections['AI Tools']" />
              <label class="custom-control-label category-label" for="customSwitch3">
                <div class="category-head">{{ $t(key.name) }}</div>
                <div v-if="Object.keys(key).includes('about')" class="config-label category-desc">
                  {{ $t(key.about) }}
                </div>
                <div v-if="showPrivilegeIds" class="category-privilege-id">
                  <span class="privilege-id-text">{{ key._id }}</span>
                  <span class="privilege-id-copy-icon" :title="$t('Click to copy')"
                    @click.prevent.stop="copyPrivilegeId(key._id)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6" />
                      <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6" />
                    </svg>
                  </span>
                </div>
              </label>
            </div>
          </template>
        </li>
      </template>
      <template v-if="userAllPrivileges['Media Pipeline']">
        <div class="pb-2 m-4 d-flex" v-if="userAllPrivileges['Media Pipeline'].length"
          style="border-bottom: 1px solid #242424;position:relative">
          <h6 class="m-0 text-left pl-4">{{ $t('Media Pipeline') }}</h6>
        </div>
        <li v-for="key in userAllPrivileges['Media Pipeline']" :key="key._id">
          <template
            v-if="!searchedKey || (searchedKey && key.name.toLowerCase().includes(searchedKey.trim().toLowerCase()))">
            <div class="custom-control custom-switch category-div">
              <input v-on:click="updatePrivileges(key, $event.target.checked, 'Media Pipeline')" type="checkbox"
                :id="key._id" class="custom-control-input"
                :checked="listOfPrivileges.includes(key._id) || selectPrivilgeSections['Media Pipeline']" />
              <label class="custom-control-label category-label" for="customSwitch6">
                <div class="category-head">{{ $t(key.name) }}</div>
                <div v-if="Object.keys(key).includes('about')" class="config-label category-desc">
                  {{ $t(key.about) }}
                </div>
                <div v-if="showPrivilegeIds" class="category-privilege-id">
                  <span class="privilege-id-text">{{ key._id }}</span>
                  <span class="privilege-id-copy-icon" :title="$t('Click to copy')"
                    @click.prevent.stop="copyPrivilegeId(key._id)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6" />
                      <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6" />
                    </svg>
                  </span>
                </div>
              </label>
            </div>
          </template>
        </li>
      </template>
      <div class="pb-2 m-4 d-flex" v-if="userAllPrivileges.Advanced && userAllPrivileges.Advanced.length"
        style="border-bottom: 1px solid #242424;position:relative">
        <h6 class="m-0 text-left pl-4">{{ $t('Administrator Privileges') }}</h6>
      </div>
      <template v-if="userAllPrivileges.Advanced">
        <li v-for="key in userAllPrivileges.Advanced" :key="key._id">
          <template
            v-if="!searchedKey || (searchedKey && key.name.toLowerCase().includes(searchedKey.trim().toLowerCase()))">
            <div class="custom-control custom-switch category-div">
              <input v-on:click="updatePrivileges(key, $event.target.checked, 'Advanced')" type="checkbox"
                class="custom-control-input"
                :checked="listOfPrivileges.includes(key._id) || selectPrivilgeSections['Advanced']" :id="key._id" />
              <label class="custom-control-label category-label" for="customSwitch4">
                <div class="category-head">{{ $t(key.name) }}</div>
                <div v-if="Object.keys(key).includes('about')" class="config-label category-desc">
                  {{ $t(key.about) }}
                </div>
                <!-- <div v-else class="config-label category-desc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </div> -->
                <div v-if="showPrivilegeIds" class="category-privilege-id">
                  <span class="privilege-id-text">{{ key._id }}</span>
                  <span class="privilege-id-copy-icon" :title="$t('Click to copy')"
                    @click.prevent.stop="copyPrivilegeId(key._id)">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.6" />
                      <path d="M4 16V6a2 2 0 0 1 2-2h10" stroke="currentColor" stroke-width="1.6" />
                    </svg>
                  </span>
                </div>
              </label>
            </div>
          </template>
        </li>
      </template>
    </ul>
    <!-- <div class="primary-btn-style">
        <button
          type="button"
          class="btn btn-outline-primary m-6"
          v-on:click="updateExtractionConfig($event)"
        >
          Save
        </button>
      </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Utils from "../../components.utils.js";

export default {
  props: ["selectedUserID", "newUser", "userType", "selectedUserInfo"],
  components: {
  },
  directives: {
    "click-outside-privilege-menu": {
      bind(el, binding, vnode) {
        el.__privilegeMenuClickOutsideHandler__ = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            if (vnode.context && vnode.context.dropdownOpen) {
              vnode.context.dropdownOpen = false;
            }
          }
        };
        document.addEventListener("click", el.__privilegeMenuClickOutsideHandler__, true);
      },
      unbind(el) {
        document.removeEventListener("click", el.__privilegeMenuClickOutsideHandler__, true);
        delete el.__privilegeMenuClickOutsideHandler__;
      }
    }
  },
  data() {
    return {
      selectedPrivileges: [],
      basicPrivileges: [],
      listOfPrivileges: [],
      userAllPrivileges: {},
      isHidden: false,
      selectedType: null,
      hideSections: {
        Basic: true,
        DAM: true,
        Archive: true,
        Advanced: true,
        "AI Tools": true,
        "Media Pipeline": true,
      },
      selectPrivilgeSections: {
        Basic: false,
        DAM: false,
        Archive: false,
        Advanced: false,
        "AI Tools": false,
        "Media Pipeline": false,
      },
      searchedKey: null,
      dropdownOpen: false,
      showPrivilegeIds: false
    };
  },
  methods: {
    hideOrShowPrivileges(type) {
      this.selectedType = type;
    },
    getUserPrivileges() {
      return this.listOfPrivileges;
    },
    updateAllPrivileges(section, keylist, isChecked) {
      let keyNameList = []
      for (let index in keylist) {
        keyNameList.push(keylist[index]._id)
      }
      let privlegesList = this.listOfPrivileges.filter((priv) => !keyNameList.includes(priv));
      if (isChecked) {
        this.listOfPrivileges = privlegesList.concat(keyNameList)
        // this.selectPrivilgeSections[section] = true
      } else {
        this.listOfPrivileges = privlegesList
        // this.selectPrivilgeSections[section] = false
      }
      if (this.newUser) {
        return
      }
      let payload = { user_id: this.selectedUserID };
      payload.access_control = { privileges: this.listOfPrivileges }
      payload.params = { user_id: this.selectedUserID }
      this.updateExistingUser(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          if (data.message.includes("Failed")) {
            this.$toast.warning(data.message);
          } else {
            if (this.getLoggedInUserId() != this.selectedUserID) {
              this.$toast.success(data.message);
            }
          }
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    updatePrivileges(key, isChecked, section) {
      if (!this.listOfPrivileges.includes(key._id)) {
        if (isChecked) {
          this.listOfPrivileges.push(key._id);
          let allPrivileges = []
          let keylist = this.userAllPrivileges[section]
          for (let index in keylist) {
            allPrivileges.push(keylist[index]._id)
          }
          // let privlegesList  =  allPrivileges.filter((priv)=> this.listOfPrivileges.includes(priv));
          // this.selectPrivilgeSections[section] = (allPrivileges.length == privlegesList.length)
        }
      } else {
        if (!isChecked) {
          this.listOfPrivileges = this.listOfPrivileges.filter((priv) => priv != key._id);
          // this.selectPrivilgeSections[section] = false
        }
      }
      if (this.newUser) {
        return
      }
      let payload = { user_id: this.selectedUserID };
      payload.access_control = { privileges: this.listOfPrivileges }
      payload.params = { user_id: this.selectedUserID }
      this.updateExistingUser(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          if (data.message.includes("Failed")) {
            this.$toast.warning(data.message);
          } else {
            if (this.getLoggedInUserId() != this.selectedUserID) {
              this.$toast.success(data.message);
            }
          }
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    getUserTypeBasedPrivileges() {
      let payload = {};
      payload.params = { user_type: this.userType };
      this.getAllPrivileges(payload).then((data => {
        this.createPrivilegesMapper(data.privileges);
      }))
    },
    createPrivilegesMapper(privilegesList) {
      this.userAllPrivileges = { Basic: [], DAM: [], Archive: [], Advanced: [], "AI Tools": [], "Media Pipeline": [] }
      for (let privilege of privilegesList) {
        if (this.userAllPrivileges[privilege.privilege_group]) {
          this.userAllPrivileges[privilege.privilege_group].push(privilege)
        }
      }
    },
    ...mapGetters("users", ["getLoggedInUserId"]),
    ...mapActions("privileges", ["getAllPrivileges"]),
    ...mapActions("users", ["getUserInfoFromServer", "updateExistingUser"]),
    togglePrivilegeIdVisibility() {
      this.showPrivilegeIds = !this.showPrivilegeIds;
      this.dropdownOpen = false;
    },
    copyPrivilegeId(privilegeId) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(privilegeId).then(() => {
          if (this.$toast) {
            this.$toast.info(this.$t ? this.$t('Privilege id copied') : 'Privilege id copied');
          }
        }).catch(() => {
          this.fallbackCopyPrivilegeId(privilegeId);
        });
      } else {
        this.fallbackCopyPrivilegeId(privilegeId);
      }
    },
    fallbackCopyPrivilegeId(privilegeId) {
      try {
        const tempInput = document.createElement("textarea");
        tempInput.value = privilegeId;
        tempInput.setAttribute("readonly", "");
        tempInput.style.position = "absolute";
        tempInput.style.left = "-9999px";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        if (this.$toast) {
          this.$toast.info(this.$t ? this.$t('Privilege id copied') : 'Privilege id copied');
        }
      } catch (err) {
        if (this.$toast) {
          this.$toast.error(this.$t ? this.$t('Unable to copy privilege id') : 'Unable to copy privilege id');
        }
      }
    }
  },
  watch: {
    userType(newVal) {
      this.userType = newVal;
      this.getUserTypeBasedPrivileges();
    }
  },
  created() {
    this.getUserTypeBasedPrivileges()
    if (!this.newUser) {
      this.listOfPrivileges = this.selectedUserInfo.access_control.privileges;
      let allPrivileges = []
      let secList = ["Basic", "DAM", "Archive", "Advanced", "AI Tools", "Media Pipeline"]
      for (let index in secList) {
        let keylist = this.userAllPrivileges[secList[index]]
        for (let index in keylist) {
          allPrivileges.push(keylist[index]._id)
        }
        // let privlegesList  =  allPrivileges.filter((priv)=> this.listOfPrivileges.includes(priv));
        // this.selectPrivilgeSections[secList[index]] = (allPrivileges.length == privlegesList.length)
      }
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$border-color: 1px solid #4a4a4a;
$border-color-only: #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color: #15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size: 14px;
$input-field-height: 38px;
$none-text-color: #4f4f4f;
$input-field-padding: .375rem 10px;
$scrollbar-thumb-background: #333;
$scrollbar-track-background: #1a1e21;
$scrollbar-thumb-on-hover-background: #555;
$tags-background-color: #282d31;
$tags-border-color: #363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$active-green-color: #28a745;
$svg-color: #666;
$learn-about-text-color-hover: #b7b327;
$active-green-icon-color: #00ff3a;
$learn-about-text-color: #9a9620;

input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: 5px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.users-basic-info-table {
  tbody {
    margin: 10px;

    .key-div {
      text-align: end;
      color: $text-color;
    }

    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}

.custom-control-input {
  z-index: 999;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.heightSet {
  // overflow: auto;
  position: absolute;
  width: 100%;
  height: calc(100% - 150px)
}

.hideShowIcons {
  position: absolute;
  inset-inline-start: 0px;
  top: -2%;
  width: 22px;
  height: 21px;
}

.bigger-checkboxes {
  height: 30px;
  width: 20px;
  position: relative;
}

.field-description {
  font-size: 11px;
  color: $dull-text-color;
}

.category-label {
  padding-top: 2px;
  font-weight: 600;
  display: block !important;
}

.category-head {
  float: inline-start;
  text-align: initial;
  width: 100%;
}

.category-desc {
  font-size: $input-field-and-label-font-size;
  color: $dull-text-color;
  text-align: start;
  font-weight: 100;
}

.category-div {
  margin-inline-start: 6%;
  margin: 25px 6%;
  width: 86%;
}

table {
  background: transparent;

  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }

  tbody {
    color: $text-color;

    td {
      border-top: none !important;
    }
  }
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.privileges-ul {
  display: inline-block;
  width: 100%;
  list-style-type: none;
  height: calc(100% - 85px);
  overflow: auto;
}

.search-bar-comm-style {
  display: flex;
  align-items: center;

  .search-bar {
    background: $primary-background !important;
    height: 40px;
    width: 250px !important;
    margin-inline-start: 3%;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color !important;
  }
}

.privilege-options-dropdown {
  position: relative;
  .three-dot-btn {
    background: transparent;
    border: none;
    border-radius: 4px;
    color: $text-color;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;

    &:hover {
      background: $bg-color-on-hover;
    }

    &:focus {
      outline: none;
    }
  }

  .three-dot-icon {
    font-size: 20px;
    line-height: 1;
  }

  .privilege-dropdown-menu {
    display: none;
    position: absolute;
    inset-inline-start: 0;
    top: calc(100% + 4px);
    min-width: 180px;
    background: $primary-background;
    border: $border-color;
    border-radius: 4px;
    padding: 0px;
    z-index: 1000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);

    &.show {
      display: block;
    }

    .dropdown-item {
      display: block;
      padding: 8px 16px;
      color: $text-color;
      font-size: $input-field-and-label-font-size;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        background: $bg-color-on-hover;
        color: $text-color;
        text-decoration: none;
      }
    }
  }
}

.category-privilege-id {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: $dull-text-color;
  text-align: start;
  font-weight: 100;
  margin: 0;
  line-height: 1.3;
  clear: both;
  width: 100%;
  box-sizing: border-box;

  .privilege-id-text {
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    cursor: text;
    word-break: break-all;
  }

  .privilege-id-copy-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    color: $dull-text-color;
    user-select: none;

    &:hover {
      color: $active-blue;
    }
  }
}
</style>